import { render, staticRenderFns } from "./CourseTeaser.vue?vue&type=template&id=5dea3eb8"
import script from "./CourseTeaser.vue?vue&type=script&lang=js"
export * from "./CourseTeaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports